module.exports = __webpack_public_path__ + "img/crate-apple.3cf651c9.svg";